import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex  items-center cursor-pointer justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        // اضافه کردن واریانت جدید شما
        berry: "bg-gradient-to-r from-[#500B0D] rounded-full to-[#E91338] hover:opacity-90 transition-opacity",
        berryBorder:"bg-[#101011] border-red-stroke rounded-full border hover:opacity-90 transition-opacity",
        whiteBorder:" border-white rounded-full border hover:opacity-90 transition-opacity text-mute",
        berryText:"bg-[#101011] text-berry-500 rounded-full  hover:opacity-90 transition-opacity ",
        outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "",
        sm: "h-8  px-3 text-xs",

        icon: "h-9 w-9",
        lg: "h-9 lg:h-11 px-4 lg:px-6 text-xs lg:text-base ",
        xl: "h-[52px] px-5 lg:px-8 text-base lg:text-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

function Button({
  className,
  variant = "default",
  size = "default",
  asChild = false,
  ...props
}) {
  const Comp = asChild ? Slot : "button"

  return (
    <Comp
      data-slot="button"
      data-variant={variant}
      data-size={size}
      className={cn(buttonVariants({ variant, size, className }))}
      {...props} />
  );
}

export { Button, buttonVariants }
